@if (inputItems().length > 1) {
  <ui-button
    uiOverlay
    [content]="allFilterContent"
    [positionStrategyMobile]="overlayMobilePositionStrategy"
    [flexibleConnectedPositionDesktop]="flexibleConnectedPositionDesktop"
    buttonStyle="text"
    icon="sliders"
    iconStyle="light"
    (clicked)="selectedItem.set(undefined)"
  >
    {{ groupLabel() }}

    @if (activeChipCount() > 0) {
      ({{ activeChipCount() }})
    }
  </ui-button>
}

@for (item of inputItems(); track item.name + item.attributes?.disabled) {
  <ui-form-chip-control
    [currentValue]="formGroup().controls[item.name]?.value"
    [config]="item"
    [disabled]="item.attributes?.disabled ?? false"
    [positionStrategyMobile]="overlayMobilePositionStrategy"
    [flexibleConnectedPositionDesktop]="flexibleConnectedPositionDesktop"
    uiOverlay
    [opened]="selectedItem() === item"
    [overlayDisabled]="item.attributes?.disabled ?? false"
    [content]="allFilterContent"
    (click)="selectedItem.set(item)"
    (overlayClosed)="selectedItem.set(undefined)"
    (clear)="formGroup().controls[item.name].setValue(item.defaultValue)"
  ></ui-form-chip-control>
}

@if (showResetAll()) {
  <ui-button
  [disabled]="activeChipCount() === 0"
  buttonStyle="text"
  (clicked)="resetControls(inputItems())"
  >
    {{ resetAllLabel() }}
  </ui-button>
}

<ng-template #allFilterContent let-overlay="overlay">
  <!-- TODO method dialog is a hotfix https://lekkerland.atlassian.net/browse/IPS-5870 -->
  <form method="dialog" [class]="overlayFormClass()" [formGroup]="formGroup()">
    <mat-card>
      <mat-card-header>
        <mat-card-title>{{ formTitle() }}</mat-card-title>
        <ui-icon-button icon="xmark-large" buttonStyle="unthemed" iconStyle="light" (clicked)="overlay.close()"></ui-icon-button>
      </mat-card-header>

      <mat-card-content>
        @for (item of formItems(); track item.name + item.attributes?.disabled) {
          <ng-template
            uiDynamicInputItem
            [item]="item"
            [formControlName]="item.name"
          ></ng-template>
        }
      </mat-card-content>

      <mat-card-actions>
        <ui-form-submit (submitted)="onSubmit($event, overlay)" [data]="submitConfig"></ui-form-submit>
      </mat-card-actions>
    </mat-card>
  </form>
</ng-template>
